import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=3d5cfc64&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=ts&"
export * from "./Price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5cfc64",
  null
  
)

export default component.exports